/**
 * Telemetry service — replaces AngularJS telemetry.js.
 * Uses Application Insights SDK loaded via index.html script tag.
 */

declare global {
  interface Window {
    initializeAppInsights?: (connectionString: string) => void
    appInsights?: {
      trackEvent: (event: { name: string }, properties?: Record<string, unknown>) => void
      trackPageView: (page: { name: string }) => void
      setAuthenticatedUserContext: (authenticatedUserId: string, accountId?: string) => void
      clearAuthenticatedUserContext: () => void
    }
  }
}

interface UserContext {
  username?: string
  id?: number | string
}

const APP_NAME = 'APS Single Lookup'

export const telemetry = {
  initialized: false,

  init(connectionString: string): void {
    try {
      if (!this.initialized && connectionString && window.initializeAppInsights) {
        window.initializeAppInsights(connectionString)
        this.initialized = true
      }
    } catch (err) {
      console.error('Telemetry init failed:', err)
    }
  },

  trackEvent(name: string, properties?: Record<string, unknown>): void {
    try {
      if (window.appInsights?.trackEvent) {
        window.appInsights.trackEvent({ name }, properties)
      }
    } catch (err) {
      console.error('Telemetry trackEvent failed:', err)
    }
  },

  trackPageView(page: string): void {
    try {
      if (window.appInsights?.trackPageView) {
        window.appInsights.trackPageView({ name: page })
      }
    } catch (err) {
      console.error('Telemetry trackPageView failed:', err)
    }
  },

  setContext(user: UserContext): void {
    try {
      if (window.appInsights?.setAuthenticatedUserContext && user.username) {
        window.appInsights.setAuthenticatedUserContext(user.username, String(user.id ?? ''))
      }
    } catch (err) {
      console.error('Telemetry setContext failed:', err)
    }
  },

  clearContext(): void {
    try {
      if (window.appInsights?.clearAuthenticatedUserContext) {
        window.appInsights.clearAuthenticatedUserContext()
      }
    } catch (err) {
      console.error('Telemetry clearContext failed:', err)
    }
  },

  appName: APP_NAME,
}
